import React, { Fragment } from "react";
import dayjs from "dayjs";
import Link from "next/link";
import Image from "next/image";
import Rupee from "@/components/ui/Rupee";

const BookingCard = ({ orders }) => {
  return (
    <div className="bg-white rounded-card-lg max-md:rounded-card border border-black/[0.06] shadow-card-sm p-5 max-md:p-4 mb-4 max-md:mb-3 transition-all duration-[250ms] ease-[cubic-bezier(0.32,0.72,0,1)] hover:shadow-card-lift hover:-translate-y-px cursor-pointer">
      <Link href={{ pathname: "/booking", query: { id: orders.id } }}>
        {orders?.vehicles?.map((item, vehIn) => {
          const { location, vehicle, rent } = item;
          return (
            <Fragment key={vehIn}>
              <div className="flex w-full flex-col lg:flex-row relative">
                <div className="pr-6 mb-3 lg:mb-0 lg:min-w-[180px]">
                  <p className="text-[12px] font-medium text-textPlaceholder tracking-[0.5px] uppercase mb-1.5">
                    TRIP ID - {orders.tripId}
                  </p>
                  <div className="mb-2">
                    {orders.status == -1 ? (
                      <span className="inline-flex items-center gap-[5px] px-2.5 py-[3px] rounded-[20px] bg-red-600/[0.08] text-dangerDeep text-xs font-semibold tracking-[0.2px]">
                        <svg width="6" height="6" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3" fill="currentColor"/></svg>
                        Cancelled
                      </span>
                    ) : orders.status == 0 || orders.status == 3 ? (
                      <span className="inline-flex items-center gap-[5px] px-2.5 py-[3px] rounded-[20px] bg-amber-500/[0.12] text-amber-700 text-xs font-semibold tracking-[0.2px]">
                        <svg width="6" height="6" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3" fill="currentColor"/></svg>
                        Payment Pending
                      </span>
                    ) : (
                      <span className="inline-flex items-center gap-[5px] px-2.5 py-[3px] rounded-[20px] bg-[rgba(84,166,36,0.1)] text-[#3d8c20] text-xs font-semibold tracking-[0.2px]">
                        <svg width="6" height="6" viewBox="0 0 6 6"><circle cx="3" cy="3" r="3" fill="#3d8c20"/></svg>
                        Confirmed
                      </span>
                    )}
                  </div>
                  <p className="text-[15px] font-semibold text-heading tracking-[-0.2px]">
                    <Rupee />{rent?.total || 0.0}
                  </p>
                </div>
                <div className="space-y-3 flex-1 max-w-full">
                  <div className="flex items-start flex-wrap gap-x-4 gap-y-1">
                    <div className="flex items-center w-[80px]">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="4" fill="#54A624"/></svg>
                      <span className="text-[13px] font-medium text-heading ml-2">Pick up</span>
                    </div>
                    <span className="text-[13px] font-medium text-heading">
                      {dayjs(orders.start).format("DD MMM YYYY, hh:mm A")}
                    </span>
                    <span className="text-[12px] text-textMuted w-full lg:flex-1 lg:w-auto">
                      {location.address.substring(0, 70)}...
                    </span>
                  </div>
                  <div className="flex items-start flex-wrap gap-x-4 gap-y-1">
                    <div className="flex items-center w-[80px]">
                      <svg width="8" height="8" viewBox="0 0 8 8" fill="none"><circle cx="4" cy="4" r="4" fill="#FF5A5F"/></svg>
                      <span className="text-[13px] font-medium text-heading ml-2">Drop Off</span>
                    </div>
                    <span className="text-[13px] font-medium text-heading">
                      {dayjs(orders.end).format("DD MMM YYYY, hh:mm A")}
                    </span>
                    <span className="text-[12px] text-textMuted w-full lg:flex-1 lg:w-auto">
                      {location.address.substring(0, 70)}...
                    </span>
                  </div>
                </div>
                <div className="absolute lg:relative -top-[8px] right-0">
                  <Image
                    src={vehicle?.imageUrl}
                    alt={vehicle?.name}
                    className="w-24 rounded-lg"
                    width={96}
                    height={72}
                  />
                </div>
              </div>
              {orders.vehicles.length != vehIn + 1 && (
                <hr className="my-4 border-lineSoft" />
              )}
            </Fragment>
          );
        })}
        {(orders.status == 0 || orders.status == 3) && (
          <div className="mt-4 pt-4 border-t border-lineSoft flex items-center justify-between flex-wrap gap-2">
            <p className="text-[13px] text-textMuted">
              Complete your payment to confirm this booking
              {orders.payableNow != null && (
                <span className="font-semibold text-heading"> — pay <Rupee />{Number(orders.payableNow).toFixed(2)} now</span>
              )}
            </p>
            <span className="inline-flex items-center px-4 py-2 rounded-[10px] bg-primary text-white text-[13px] font-semibold">
              Complete payment
            </span>
          </div>
        )}
      </Link>
    </div>
  );
};

export default BookingCard;
